import React, { useContext, useEffect, useState } from "react";
import { Button, Table, Tooltip, Popover as PopoverAntd, Space } from "antd";
import { putPostRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import { ToastContextDispatch } from "Context/CommonContext";
import {
  BASE_URL,
  GET_TESTSYLLABUS_STATUS,
  REFRESH_PLANNED_LECTURES,
} from "utilFunctions/Constants/urlConstants";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import {
  returnBatchData,
  returnPlannedLecture,
  // returnRiskSegment,
} from "Pages/SyllabusCompliances/SyllabusComplianceBatchTable";
import {
  calculateCumulativePercentage,
  returnMarkedvaluue,
  returnPercentage,
  returnTargetValuue,
} from "Pages/Faculties/FacultiesTable";
import "./index.css";
// import { displayNumberWithDecimals } from "Pages/BranchHealth/BranchHealthTable";
// import {
//   calculatePercentage,
//   roundToAnyDecimalPlaces,
// } from "utilFunctions/helperFunctions/utilFunctions";
import Typography from "Components/CommonComponents/Typography";
import { useNavigate } from "react-router-dom";
import InfoIcon from "Assets/Icons/InfoIcon";
import moment from "moment";
import { capitalize } from "lodash";
import { DivStyledStatus, returnColor } from "Pages/MyLibrary/MyLibraryTable";
import { popBodyShowComponentAntd } from "Pages/SyllabusCompliances/SyllabusComplainceBatchAntdTable";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
const returnPlannedLectured = (arr: any, batchId: any) => {
  return arr.find((ele: any) => ele.batchId == batchId);
};

interface MyBatchesTableAntdIF {
  data: any[];
  access: string;
  setData: any;
}
const MyBatchesTableAntd = ({
  data,
  access,
  setData,
}: MyBatchesTableAntdIF) => {
  const { screen }: any = useWindowSize();
  const navigate = useNavigate();
  const [refreshData, setRefreshData] = useState<any>([]);
  const ToastDispatch = useContext(ToastContextDispatch);
  const [isSync, setIsSync] = useState(false);
  const [testSyllbStatus, setTestSyllabusStatus] = useState<any>([]);
  const { makeRequest: PostTestSyllabusStatus } = usePutPostAPI(
    (data: any) => {
      if (data["data"] && data["data"].length) {
        setTestSyllabusStatus(data["data"]);
      } else {
        setTestSyllabusStatus([]);
      }
    },
    (error) => {
      if (error && error["message"]) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    },
    "Post"
  );
  useEffect(() => {
    if (data && data.length > 0) {
      const url = BASE_URL + GET_TESTSYLLABUS_STATUS;
      const obj = (data || []).map((ele: any) => ({
        batchId: ele.batchId,
        testScheduleId: ele.testId,
      }));
      const filteredList = obj.filter((ele: any) => ele.testScheduleId != null);
      if (filteredList.length > 0) {
        PostTestSyllabusStatus(url, filteredList);
      }
    }
  }, [data]);
  const PostRefreshPlannedLectures = (url: string, body: any, batchId: any) => {
    setIsSync(true);
    setData(data.map((ele: any) => ({ ...ele, chapterData: null })));
    putPostRequest({
      url: url,
      success: (data: any) => {
        const res = data["data"];
        ToastDispatch({
          isOpen: true,
          type: "success",
          message: res?.message,
        });
        if (res && res["data"]) {
          setRefreshData((prev: any) => [
            ...prev,
            {
              batchId: batchId,
              ...res["data"],
            },
          ]);
        } else {
          setRefreshData([]);
        }
        setIsSync(false);
      },
      failure: (err: any) => {
        setRefreshData([]);
        setIsSync(false);
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message:
            err?.response?.data?.code == "400"
              ? err?.response?.data?.message
              : "Something went wrong",
        });
      },
      body: body,
      method: "Post",
    } as any);
  };
  const routeToMyBatch = (item: any) => {
    navigate("/admin/mybatch/" + item.batchId, {
      replace: false,
      state: {
        batch: item,
      },
    });
  };
  const routeToTest = (item: any) => {
    const testDetails = {
      type: item.testType,
      startDate: item.startDate,
      endDate: item.endDate,
    };
    navigate("/admin/mybatch/test/" + item.testId, {
      replace: false,
      state: {
        test: testDetails,
        batchId: item.batchId,
        testSyllabusStatus: testSyllbStatus,
        batchName: item.batchName,
      },
    });
  };
  const renderingTime = (date: any) => {
    return <div className="d-flex">{moment(date).format("D MMM")}</div>;
  };
  const columns: any = [
    {
      title: "Batch Name",
      dataIndex: "batchName",
      width: 220,
      fixed: ["xxl", "xl", "lg"].includes(screen) ? "left" : false,
      access: ["Batches", "Dashboard"],
      render: (_: any, record: any) => {
        return (
          <span className="tableIdStyle" onClick={() => routeToMyBatch(record)}>
            {record.batchName}
          </span>
        );
      },
    },
    {
      title: "Class",
      dataIndex: "class",
      width: 90,
      access: ["Batches"],
      render: (_: any, record: any) => {
        return <>{capitalize(record.class)}</>;
      },
    },
    {
      title: "Subject",
      dataIndex: "subject",
      access: ["Batches"],
      render: (_: any, record: any) => {
        return record.subject == "NA" ? (
          <Space>
            <Tooltip title="User is coordinator for this batch.">
              <span>{record.subject}</span>
              <InfoIcon id={"Tooltip-subject-NA"}></InfoIcon>
            </Tooltip>
          </Space>
        ) : (
          <span className="tableIdStyle">{record.subject}</span>
        );
      },
    },
    {
      title: () => (
        <Tooltip title="Percentage of planned lectures completed against the monthly target set by the central team">
          <span>Monthly Target %</span>
          <InfoIcon id={"Tooltip-attendance1"}></InfoIcon>
        </Tooltip>
      ),
      dataIndex: "plLecStatus",
      access: ["Batches", "Dashboard"],
      width: 160,
      render: (_: any, item: any) => {
        return item?.plLecStatus && item?.plLecStatus != null ? (
          <PopoverAntd
            placement="leftTop"
            content={() => (
              <>
                {returnTargetValuue(
                  "Marked planned lectures",
                  "Cumulative monthly target",
                  item?.plLecStatus?.markedPlLecCount,
                  item?.plLecStatus?.monthlyTarget
                ).map((ele: any, index: number) => (
                  <div
                    key={index}
                    className="markedLectureCountStyle d-flex flex-column justify-content-between mb-2"
                  >
                    <div className="d-flex flex-row w-100">
                      <Typography variant="h6" color="black">
                        {ele.label} &nbsp;
                      </Typography>
                      <Typography variant="h6" color="black">
                        {ele.value}
                      </Typography>
                    </div>
                  </div>
                ))}
              </>
            )}
            title={""}
          >
            <div
              className={
                item?.plLecStatus?.monthlyTarget &&
                item?.plLecStatus?.monthlyTarget != null
                  ? "filterSpan"
                  : ""
              }
            >
              {item?.plLecStatus?.monthlyTarget != undefined &&
              item?.plLecStatus?.monthlyTarget != null
                ? calculateCumulativePercentage(item?.plLecStatus) + "%"
                : "-"}
            </div>
          </PopoverAntd>
        ) : (
          "-"
        );
      },
    },
    {
      title: () => (
        <Tooltip title="Shows the number of lectures covered compared to the total number of planned lectures according to the central lecture planner">
          <span>Syllabus Status</span>
          <InfoIcon id={"Tooltip-attendance1"}></InfoIcon>
        </Tooltip>
      ),
      dataIndex: "plLecStatus",
      access: ["Batches"],
      width: 150,
      render: (_: any, item: any) => {
        return (
          <div style={{ width: "400px !important" }}>
            {item.chapterData ? (
              <div className="d-flex flex-row">
                <div>
                  <span className="studentLabel">Chapter : </span>
                  <span className="studentValue">
                    {item?.chapterData?.markedChapters}/
                    {item?.chapterData?.totalChapters}
                  </span>
                </div>
              </div>
            ) : (
              <>
                <>
                  {!returnPlannedLectured(refreshData, item.batchId) ? (
                    <div className="d-flex flex-row">
                      {item?.plLecStatus?.totalPlLecCount && (
                        <div>
                          <span className="studentLabel">PL : </span>
                          <span className="studentValue">
                            {item?.plLecStatus?.markedPlLecCount}/
                            {item?.plLecStatus?.totalPlLecCount}
                          </span>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="d-flex flex-row">
                      <div>
                        <span className="studentLabel">Planned Lectures </span>
                        <span className="studentValue">
                          {
                            returnPlannedLectured(refreshData, item.batchId)
                              ?.totalMarked
                          }
                          /
                          {
                            returnPlannedLectured(refreshData, item.batchId)
                              ?.totalPlannedLecture
                          }
                        </span>
                      </div>
                    </div>
                  )}
                </>
              </>
            )}
          </div>
        );
      },
    },
    {
      title: () => (
        <Tooltip title="Test scheduled in the next 30 days.">
          <span>Upcoming Tests</span>
          <InfoIcon id={"Tooltip-attendance1"}></InfoIcon>
        </Tooltip>
      ),
      dataIndex: "testType",
      access: ["Batches", "Dashboard"],
      width: 220,
      render: (_: any, item: any) => {
        return (
          <div className="d-flex flex-row gap-2 align-items-center">
            {item?.testType && item.testType === "No Upcoming Test" ? (
              <span>{"Not Scheduled"}</span>
            ) : (
              <span className="filterSpan" onClick={() => routeToTest(item)}>
                {item?.testType}
              </span>
            )}{" "}
            |<span>{item.testDate && renderingTime(item.testDate)}</span>
          </div>
        );
      },
    },
    {
      title: () => (
        <Tooltip title="Indicates the topics covered in the subject for the upcoming test of the particular batch.">
          <span>Test Syllabus Status</span>
          <InfoIcon id={"Tooltip-attendance1"}></InfoIcon>
        </Tooltip>
      ),
      dataIndex: "testSyllbStatus",
      access: ["Batches", "Dashboard"],
      width: 250,
      render: (_: any, item: any) => {
        return (
          <div>
            {returnBatchData(testSyllbStatus, item.batchId) ? (
              <PopoverAntd
                placement="leftTop"
                content={() => (
                  <div className="popup-class-scroll-style">
                    {returnBatchData(testSyllbStatus, item.batchId).map(
                      (ele: any, index: number) => (
                        <div
                          key={index}
                          className="d-flex justify-content-between mb-2"
                        >
                          <div key={ele.value + index}>
                            <DivStyledStatus color={returnColor(ele?.subject)}>
                              {ele?.subject}
                            </DivStyledStatus>
                          </div>
                          <div className="statusHeading">
                            {returnPlannedLecture(
                              ele.markedNodeCount,
                              ele.totalNodeCount
                            )}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}
                title={"Total topics covered for the test"}
              >
                {returnBatchData(testSyllbStatus, item.batchId)
                  ? popBodyShowComponentAntd(
                      returnBatchData(testSyllbStatus, item.batchId)
                    )
                  : "-"}
              </PopoverAntd>
            ) : (
              "-"
            )}
          </div>
        );
      },
    },
    {
      title: "Unmarked lectures",
      dataIndex: "unMarkedLectureCount",
      access: ["Batches", "Dashboard"],
      width: 160,
      render: (_: any, item: any) => {
        return <div>{item?.unMarkedLectureCount}</div>;
      },
    },
    {
      title: "Total Students",
      dataIndex: "totalNumberOfStudents",
      access: ["Batches"],
      render: (_: any, item: any) => {
        return <div>{item?.totalNumberOfStudents}</div>;
      },
    },
    {
      title: "Marked Attendance %",
      dataIndex: "markedAttdCount",
      access: ["Batches"],
      render: (_: any, item: any) => {
        return (
          <PopoverAntd
            placement="leftTop"
            content={() => (
              <>
                {returnMarkedvaluue(
                  "Attendance",
                  item.markedAttdCount,
                  item.unmarkedAttdCount
                ).map((ele: any, index: number) => (
                  <div
                    key={index}
                    className="markedLectureCountStyle d-flex flex-column justify-content-between mb-2"
                  >
                    <div className="d-flex flex-row w-100">
                      <Typography variant="h6" color="black">
                        {ele.label} &nbsp;
                      </Typography>
                      <Typography variant="h6" color="black">
                        {ele.value}
                      </Typography>
                    </div>
                  </div>
                ))}
              </>
            )}
            title={""}
          >
            <div
              className={
                returnPercentage(item.markedAttdCount, item.unmarkedAttdCount)
                  ? "filterSpan"
                  : ""
              }
            >
              {returnPercentage(item.markedAttdCount, item.unmarkedAttdCount)
                ? returnPercentage(
                    item.markedAttdCount,
                    item.unmarkedAttdCount
                  ) + "%"
                : "-"}
            </div>
          </PopoverAntd>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      access: ["Batches"],
      render: (_: any, item: any) => {
        return (
          <div className="d-flex align-items-center justify-content-center">
            {item.chapterData ? (
              <div>-</div>
            ) : (
              <div>
                {item?.plLecStatus?.courseId ? (
                  <Button
                    className="filterSpan"
                    onClick={() => {
                      const obj = {
                        batchId: item.batchId,
                        courseId: item?.plLecStatus?.courseId,
                        doRefresh: true,
                      };
                      const url = BASE_URL + REFRESH_PLANNED_LECTURES;
                      PostRefreshPlannedLectures(url, obj, item.batchId);
                    }}
                    disabled={isSync}
                    type="text"
                  >
                    Sync
                  </Button>
                ) : (
                  <div>-</div>
                )}
              </div>
            )}
          </div>
        );
      },
    },
  ];
  return (
    <>
      <Table
        scroll={{ x: "max-content" }}
        bordered
        size="small"
        columns={columns.filter((ele: any) => ele.access.includes(access))}
        dataSource={data}
        pagination={false}
      />
    </>
  );
};

export default MyBatchesTableAntd;
